import moment from 'moment'
import Colors from 'styles/Colors'
import { ContentfulArticle } from 'Types'

export function formatCategory(name: string) {
  return name.split('-')[0]
}

export function formatDate(date: string) {
  const d = moment(date)
  if (d.isValid()) {
    return d.format('MMM. D, Y')
  }
}

export function formatPath(title: string) {
  return title
    .split(' ')
    .map((e) => e.replace(/[^a-z0-9.]/gi, ''))
    .join('-')
    .toLowerCase()
}

export function getFilters(articles: ContentfulArticle[], type: string) {
  return type
    ? [
        ...new Set(
          [...articles]
            .filter((article) => article.type === type)
            .map((article) => article.category.split('-')[0])
        ),
      ]
    : ''
}

export function getBulletColor(type: string) {
  if (type === 'Blog' || type === 'Support') {
    return Colors.blueYonder
  }
  if (type === 'News') {
    return Colors.earthYellow
  }
  if (type === 'Guides') {
    return Colors.neptune
  }
}
